import React, { useContext } from 'react';
import {
  Typography,
  CardBody,
} from '@one-thd/sui-atomic-components';
import { string } from 'prop-types';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import NullViewTexts from '../../../constants/NullViewTexts';
import { showAboveSmBreakpoint, showBelowSmBreakpoint } from '../../../constants/responsiveClassNames';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const ListsNullView = ({ componentId }) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';


  const {
    cardTitle, benefits, imageAlt, cta, imageUrl
  } = NullViewTexts;

  const cardBody = (
    <CardBody>
      <ul
        className="sui-list-disc sui-list-outside sui-ml-4 sui-mb-0 sui-pb-4"
      >
        {benefits?.map((benefit, index) => (
          <li key={index}>
            <Typography>{benefit}</Typography>
          </li>
        ))}
      </ul>
    </CardBody>
  );

  return (
    <div
      className="sui-@container sui-h-full"
      data-testid="lists-null-view"
    >
    {isMobile ? (
      <div id="lists-compact-null-view">
        <CompactNullView
          cardBody={cardBody}
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          cardTitle={cardTitle}
          cta={cta}
          componentId={componentId}
        />
      </div> ) : (
      <div id="lists-desktop-null-view">
        <DesktopNullView
          cardBody={cardBody}
          imageUrl={imageUrl}
          imageAlt={imageAlt}
          cardTitle={cardTitle}
          cta={cta}
          componentId={componentId}
        />
      </div> 
    )}
    </div>
  );
};

ListsNullView.propTypes = {
  componentId: string,
};

ListsNullView.defaultProps = {
  componentId: '',
};

export default ListsNullView;
